/* ============================================================
   Collections Marquee — assets/collections-marquee.js
   ============================================================ */

(function () {
  document.querySelectorAll('.collections-marquee__track-wrap').forEach(function (wrap) {
    const track = wrap.querySelector('.collections-marquee__track');
    if (!track) return;

    const speed        = parseFloat(wrap.dataset.speed) || 28;
    const pauseOnHover = wrap.dataset.pauseOnHover !== 'false';

    /* ── Clone cards for seamless infinite loop ── */
    Array.from(track.children).forEach(function (card) {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    /* ── Start animation ── */
    track.style.animationDuration = speed + 's';
    track.classList.add('is-animating');

    /* ── Pause on hover ── */
    if (pauseOnHover) {
      wrap.addEventListener('mouseenter', function () {
        if (!isDragging) track.classList.add('is-paused');
      });
      wrap.addEventListener('mouseleave', function () {
        if (!isDragging) track.classList.remove('is-paused');
      });
    }

    /* ── Drag-to-scroll with animation offset sync ── */
    let isDragging  = false;
    let startX      = 0;
    let animOffset  = 0;

    function getCurrentTranslateX() {
      const matrix = new DOMMatrix(window.getComputedStyle(track).transform);
      return matrix.m41;
    }

    function startDrag(clientX) {
      isDragging  = true;
      startX      = clientX;
      animOffset  = getCurrentTranslateX();
      track.classList.add('is-paused');
      wrap.classList.add('is-grabbing');
      track.style.transform = 'translateX(' + animOffset + 'px)';
    }

    function moveDrag(clientX) {
      if (!isDragging) return;
      const delta = clientX - startX;
      let next    = animOffset + delta;
      const half  = track.scrollWidth / 2;
      next = ((next % half) - half) % half;
      track.style.transform = 'translateX(' + next + 'px)';
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      wrap.classList.remove('is-grabbing');

      /* Resume animation from current visual position */
      const current = getCurrentTranslateX();
      const half    = track.scrollWidth / 2;
      const elapsed = (Math.abs(current) / half) * speed;

      track.style.transform      = '';
      track.style.animationDelay = '-' + elapsed + 's';
      track.classList.remove('is-paused');
    }

    /* Mouse */
    wrap.addEventListener('mousedown', function (e) {
      startDrag(e.clientX);
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) { moveDrag(e.clientX); });
    window.addEventListener('mouseup',   endDrag);

    /* Touch */
    wrap.addEventListener('touchstart', function (e) {
      startDrag(e.touches[0].clientX);
    }, { passive: true });

    wrap.addEventListener('touchmove', function (e) {
      moveDrag(e.touches[0].clientX);
    }, { passive: true });

    wrap.addEventListener('touchend', endDrag);
  });
})();
